import BaseService from "./BaseService";
import { RequestDto } from "./dtos/request/RequestDto";

interface PdfBuffer {
  pdf: {
    type: "buffer";
    data: number[];
  };
}

export class PDFService extends BaseService {
  private resource = "/pdf";

  async getPDF(
    params: { userId: number },
    onSuccess: (data: PdfBuffer) => void,
    onError: (errorMessage: string) => void
  ) {
    const reqParams = new RequestDto(this.resource, params);
    await this.doGet<PdfBuffer>(reqParams, onSuccess, onError);
  }

  async getTipConfirmationPDF(
    params: { tipId: number },
    onSuccess: (data: PdfBuffer) => void,
    onError: (errorMessage: string) => void
  ) {
    const reqParams = new RequestDto(`${this.resource}/tip-confirmation`, params);
    await this.doGet<PdfBuffer>(reqParams, onSuccess, onError);
  }
}

export type { PdfBuffer };


